module.exports = __webpack_public_path__ + "img/maison15.673e2fdc.jpg";